import { Image, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { colors, media, mediaQueries } = theme;

export const ArticleTileWrapper = styled.div`
  border: 1px solid ${colors.grey20};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem;
  width: 100%;

  ${mediaQueries.above(media.lg)} {
    max-height: 37.75rem;
    max-width: 23.5rem;
  }
`;

export const StyledImage = styled(Image)`
  aspect-ratio: auto;
  margin-bottom: 1rem;
  object-fit: contain;
  width: 100%;
  height: 11.25rem;
  
  ${mediaQueries.above(media.lg)} {
    height: 7.5rem;
    width 18.75rem;
  }
`;

export const HeadingWrapper = styled.div`
  align-items: center;
  display: flex;
`;
